//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaColumn', {
//        templateUrl: 'views/components/views/metaColumn/metaColumn.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'utilityService', 'metaColumnService', function ($stateParams, stateService, translateService, modalService, utilityService, metaColumnService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;
//            let metaColumnKeyno = $stateParams.metacolumn_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                metaColumnKeyno: metaColumnKeyno,
//                colNameTranslatedButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('translateedit', { item_id: vm.model.edit.colname }) }
//                ],
//                edit: {},
//                selectListElementTypes: [],
//                metaColumnItems: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await metaColumnService.getMetaColumn({
//                    metatable_keyno: metaTableKeyno,
//                    metacolumn_keyno: metaColumnKeyno
//                }))[0];

//                _loadMetaColumnItems();
//            }

//            async function loadElementTypes() {
//                vm.model.selectListElementTypes = await metaColumnService.listElementTypes();
//            }

//            async function _loadMetaColumnItems() {
//                if (vm.model.edit.metacolumn_keyno > 0) {
//                    vm.model.metaColumnItems = await metaColumnService.getMetaColumnItems(vm.model.edit.metacolumn_keyno);
//                }
//            }

//            function retrieveTranslatedColumnName() {
//                if (utilityService.validateParmsValue(vm.model.edit.colname, true) !== true) return;

//                return metaColumnService.getTranslatedColumnName({ colname: vm.model.edit.colname }).then(function (data) {
//                    vm.model.edit.colname_translated = data[0].colname_translated;
//                });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'colname':
//                        if (utilityService.validateParmsValue(vm.model.edit.colname, true) !== true) return;

//                        retrieveTranslatedColumnName();
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                metaColumnService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: vm.model.edit.delete_warning,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    metaColumnService.deleteObj(vm.model.edit).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: (dialogItself) => {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadElementTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
